// extracted by mini-css-extract-plugin
export default {"Box":"TableOfContentsPanel-module__Box--fnjeX","NavList":"TableOfContentsPanel-module__NavList--bSFug"};